// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Syne:wght@700;800&family=DM+Mono:wght@400;500&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   Sidebar.css  —  KinetiQ premium sidebar
   Design: deep slate-navy, #28a745 accent, scientific SaaS
   Tracker #6:  larger font, button-style items, more spacing
   Tracker #7:  highly visible active state (glow + bar + bg)
   Tracker #8:  generous padding throughout
   Help menu:   scroll-select dropdown (button, not link)
   ============================================================ */

   /* ── Design tokens ─────────────────────────────────────────── */
   :root {
     --sb-bg:          #1A3C6E;
     --sb-surface:     #1e2c3e;
     --sb-border:      rgba(252, 13, 13, 0.07);
     --sb-border-mid:  rgba(245, 26, 26, 0.12);
     --sb-accent:      #07c436;
     --sb-accent-dim:  rgba(4, 240, 59, 0.14);
     --sb-accent-glow: rgba(12, 238, 65, 0.35);
     --sb-icon:        #6b8699;
     --sb-subicon:     #fdfdfd;
     --sb-text:        #000408;
     --sb-text-mid:    #fdfdfd;
     --sb-text-dim:    #fdfdfd;
     --sb-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;
     --sb-font-mono:   'DM Mono', 'JetBrains Mono', monospace;
     --sb-font-brand:  'Syne', 'Lexend', sans-serif;
     --sb-radius:      9px;
     --sb-radius-sm:   6px;
     --sb-transition:  0.16s cubic-bezier(0.4, 0, 0.2, 1);
     --sb-width:       242px;
   }
   
   /* ─────────────────────────────────────────────────────────────
      Full sidebar
   ───────────────────────────────────────────────────────────── */
   .sb-sidebar {
     width: var(--sb-width);
     min-width: var(--sb-width);
     height: 100vh;
     /* background: var(--sb-bg); */
     background: linear-gradient(160deg, var(--sb-bg) 0%, #0E2A52 55%, var(--kinetic-dark) 100%);
     display: flex;
     flex-direction: column;
     position: fixed;
     top: 0;
     left: 0;
     z-index: 100;
     border-right: 1px solid var(--sb-border);
     box-shadow: 4px 0 32px rgba(233, 219, 219, 0.4);
     overflow-y: auto;
     overflow-x: hidden;
     scrollbar-width: none;
   }
   .sb-sidebar::-webkit-scrollbar { display: none; }
   
   /* ─────────────────────────────────────────────────────────────
      Collapsed rail
   ───────────────────────────────────────────────────────────── */
   .sb-rail {
     width: 58px;
     height: 100vh;
     background: var(--sb-bg);
     display: flex;
     flex-direction: column;
     align-items: center;
     position: fixed;
     top: 0;
     left: 0;
     z-index: 100;
     border-right: 1px solid var(--sb-border);
     padding: 16px 0 16px;
     gap: 0;
   }
   
   .sb-rail-logo {
     width: 38px;
     height: 38px;
     background: var(--sb-accent-dim);
     border: 1px solid rgba(40, 167, 69, 0.35);
     border-radius: 10px;
     display: flex;
     align-items: center;
     justify-content: center;
     color: var(--sb-accent);
     margin-bottom: 16px;
     box-shadow: 0 0 14px rgba(40, 167, 69, 0.15);
     flex-shrink: 0;
   }
   
   .sb-rail-nav {
     flex: 1 1;
     display: flex;
     flex-direction: column;
     gap: 4px;
     padding: 0 10px;
     width: 100%;
   }
   
   .sb-rail-item {
     display: flex;
     align-items: center;
     justify-content: center;
     width: 38px;
     height: 38px;
     border-radius: 9px;
     color: var(--sb-icon);
     text-decoration: none;
     transition: background var(--sb-transition), color var(--sb-transition);
   }
   .sb-rail-item:hover {
     background: rgba(236, 8, 8, 0.06);
     color: var(--sb-text);
   }
   .sb-rail-item--active {
     background: var(--sb-accent-dim);
     color: var(--sb-accent);
     border: 1px solid rgba(40, 167, 69, 0.3);
     box-shadow: 0 0 10px rgba(40, 167, 69, 0.15);
   }
   
   .sb-rail-expand {
     margin-top: auto;
     background: none;
     border: 1px solid var(--sb-border);
     border-radius: 8px;
     cursor: pointer;
     color: var(--sb-icon);
     padding: 7px;
     display: flex;
     align-items: center;
     justify-content: center;
     transition: background var(--sb-transition), color var(--sb-transition), border-color var(--sb-transition);
   }
   .sb-rail-expand:hover {
     background: rgba(235, 8, 8, 0.07);
     color: var(--sb-text);
     border-color: var(--sb-border-mid);
   }
   
   /* ─────────────────────────────────────────────────────────────
      Header
   ───────────────────────────────────────────────────────────── */
   .sb-header {
     padding: 20px 16px 16px;
     display: flex;
     align-items: center;
     justify-content: space-between;
     gap: 8px;
     flex-shrink: 0;
     overflow: hidden;
   }
   
   .sb-logo-row {
     display: flex;
     align-items: center;
     gap: 11px;
     flex: 1 1;
     min-width: 0;
     overflow: hidden;
   }
   
   .sb-logo-mark {
     width: 40px;
     height: 40px;
     background: linear-gradient(135deg, rgba(40, 167, 69, 0.22) 0%, rgba(40, 167, 69, 0.06) 100%);
     border: 1px solid rgba(40, 167, 69, 0.4);
     border-radius: 11px;
     display: flex;
     align-items: center;
     justify-content: center;
     color: #28a745;
     flex-shrink: 0;
     box-shadow: 0 0 16px rgba(223, 83, 3, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.06);
   }
   
   .sb-logo-name {
     font-family: var(--sb-font-brand);
     font-size: 19px;
     font-weight: 800;
     color: #068af7;
     letter-spacing: -0.03em;
     line-height: 1.1;
   }
   
   .sb-logo-tag {
     font-family: var(--sb-font-mono);
     font-size: 9.5px;
     font-weight: 500;
     color: var(--sb-text-dim);
     letter-spacing: 0.07em;
     text-transform: uppercase;
     margin-top: 2px;
   }
   
   .sb-collapse-btn {
     background: none;
     border: 1px solid var(--sb-border);
     border-radius: 7px;
     cursor: pointer;
     color: var(--sb-icon);
     padding: 5px;
     display: flex;
     align-items: center;
     justify-content: center;
     flex-shrink: 0;
     transition: background var(--sb-transition), color var(--sb-transition), border-color var(--sb-transition);
   }
   .sb-collapse-btn:hover {
     background: rgba(255, 255, 255, 0.07);
     color: var(--sb-text);
     border-color: var(--sb-border-mid);
   }
   
   /* ─────────────────────────────────────────────────────────────
      Dividers & labels
   ───────────────────────────────────────────────────────────── */
   .sb-divider {
     height: 1px;
     background: var(--sb-border);
     margin: 0 16px;
     flex-shrink: 0;
   }
   
   .sb-section-label {
     padding: 14px 20px 6px;
     font-size: 9.5px;
     font-weight: 600;
     letter-spacing: 0.1em;
     color: var(--sb-text-dim);
     font-family: var(--sb-font-mono);
     text-transform: uppercase;
     flex-shrink: 0;
   }
   
   /* ─────────────────────────────────────────────────────────────
      Nav items
   ───────────────────────────────────────────────────────────── */
   .sb-nav {
     display: flex;
     flex-direction: column;
     gap: 3px;
     padding: 0 10px;
     flex-shrink: 0;
   }
   
   .sb-nav-row {
     display: flex;
     align-items: center;
     position: relative;
   }
   
   .sb-nav-link {
     display: flex;
     align-items: center;
     gap: 10px;
     flex: 1 1;
     text-decoration: none;
     padding: 10px 12px;
     border-radius: var(--sb-radius);
     color: var(--sb-text-mid);
     font-size: 20px;
     font-weight: 500;
     font-family: var(--sb-font-ui);
     letter-spacing: 0.01em;
     transition: background var(--sb-transition), color var(--sb-transition), box-shadow var(--sb-transition);
     position: relative;
     overflow: hidden;
     border: 1px solid transparent;
   }
   
   /* Button-reset for nav items that are <button> not <a> */
   .sb-nav-link--btn {
     width: 100%;
     background: none;
     cursor: pointer;
     text-align: left;
   }
   
   .sb-nav-link:hover,
   .sb-nav-link--hover {
     background: rgba(255, 255, 255, 0.05);
     color: var(--sb-text);
   }
   
   .sb-nav-link--active {
     background: linear-gradient(90deg, rgba(40, 167, 69, 0.18) 0%, rgba(40, 167, 69, 0.05) 100%);
     color: #ffffff;
     font-weight: 600;
     border-color: rgba(40, 167, 69, 0.28);
     box-shadow: 0 2px 12px rgba(40, 167, 69, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.05);
   }
   
   /* Green accent bar on active item */
   .sb-accent-bar {
     position: absolute;
     left: 0;
     top: 18%;
     bottom: 18%;
     width: 3px;
     background: var(--sb-accent);
     border-radius: 0 3px 3px 0;
     box-shadow: 0 0 10px rgba(40, 167, 69, 0.7);
   }
   
   .sb-nav-icon {
     display: flex;
     align-items: center;
     color: var(--sb-icon);
     flex-shrink: 0;
     transition: color var(--sb-transition);
   }
   .sb-nav-icon--active { color: var(--sb-accent); }
   
   .sb-nav-link--active .sb-nav-icon {
     color: var(--sb-accent);
   }
   
   .sb-nav-label {
     flex: 1 1;
     white-space: nowrap;
     overflow: hidden;
     text-overflow: ellipsis;
   }
   
   /* Chevron inline inside the Help button */
   .sb-help-chevron {
     display: flex;
     align-items: center;
     color: var(--sb-icon);
     flex-shrink: 0;
     margin-left: auto;
     padding-left: 4px;
   }
   
   /* .sb-chevron-btn removed — chevron is now embedded inside the nav button */
   
   /* ─────────────────────────────────────────────────────────────
      Sub-menu  (shared — Data Fitting & Help)
   ───────────────────────────────────────────────────────────── */
   .sb-sub-menu {
     margin: 2px 10px 4px 32px;
     border-left: 1px solid rgba(40, 167, 69, 0.22);
     padding-left: 10px;
     display: flex;
     flex-direction: column;
     gap: 1px;
     animation: sbSlideDown 0.2s cubic-bezier(0.4, 0, 0.2, 1);
   }
   
   .sb-sub-link {
     display: flex;
     align-items: center;
     gap: 8px;
     color: var(--sb-subicon);
     text-decoration: none;
     padding: 5px 22px;
     border-radius: 7px;
     font-size: 18px;
     font-weight: 500;
     font-family: var(--sb-font-ui);
     letter-spacing: 0.01em;
     line-height: 1.2;
     white-space: nowrap;
     transition: background var(--sb-transition), color var(--sb-transition);
     position: relative;
     border: 1px solid transparent;
   }
   
   /* Button-reset for help sub-items that are <button> */
   .sb-sub-link--btn {
     width: 100%;
     background: none;
     cursor: pointer;
     text-align: left;
   }
   
   .sb-sub-link:hover,
   .sb-sub-link--hover {
     background: rgba(255, 255, 255, 0.05);
     color: #ccb3a4;
   }
   
   .sb-sub-link--active {
     background: #ffffff;
     color: #0a1a12;
     font-weight: 600;
     border-color: rgba(40, 167, 69, 0.25);
   }
   
   .sb-sub-icon { color: var(--sb-subicon); transition: color var(--sb-transition); flex-shrink: 0; display: flex; align-items: center; }
   .sb-sub-icon--active { color: var(--sb-accent); }
   
   .sb-sub-dot {
     margin-left: auto;
     width: 5px;
     height: 5px;
     border-radius: 50%;
     background: var(--sb-accent);
     box-shadow: 0 0 6px rgba(40, 167, 69, 0.8);
     flex-shrink: 0;
   }
   
   /* Chevron on the "User Guide" row — same rotate-on-expand behavior as
      the top-level Help chevron, scaled down to sit inside a sub-link. */
   .sb-guide-chevron {
     display: flex;
     align-items: center;
     color: inherit;
     flex-shrink: 0;
     margin-left: auto;
     padding-left: 4px;
     opacity: 0.75;
   }
   
   .sb-guide-chevron svg {
     width: 10px;
     height: 10px;
   }
   
   /* ─────────────────────────────────────────────────────────────
      Help sub-menu overrides
      Slightly tighter indent since Help items have their own icons
   ───────────────────────────────────────────────────────────── */
   .sb-help-menu {
     margin-top: 0;
     margin-bottom: 6px;
   }
   
   .sb-help-menu .sb-sub-link {
     padding: 6px 14px;
     font-size: 18px;
     white-space: nowrap;
   }
   
   /* ─────────────────────────────────────────────────────────────
      User Guide section list — nested one level under "User Guide"
      itself, inside the Help sub-menu. Dynamic loading: each link is
      /userguide plus a different hash, so clicking swaps the guide's
      content in place rather than leaving the page.
   ───────────────────────────────────────────────────────────── */
   .sb-guide-menu {
     margin: 2px 0 6px 24px;
     border-left: 1px solid rgba(40, 167, 69, 0.16);
     padding-left: 8px;
   }
   
   .sb-guide-menu .sb-sub-link {
     padding: 5px 12px;
     font-size: 15px;
     gap: 8px;
   }
   
   .sb-guide-menu .sb-sub-icon svg {
     opacity: 0.7;
   }
   
   /* ─────────────────────────────────────────────────────────────
      Quick actions
   ───────────────────────────────────────────────────────────── */
   .sb-quick-actions {
     padding: 4px 10px 10px;
   }
   
   .sb-quick-btn {
     display: flex;
     align-items: center;
     gap: 9px;
     color: var(--sb-text-mid);
     text-decoration: none;
     padding: 9px 12px;
     border-radius: var(--sb-radius);
     font-size: 13px;
     font-weight: 400;
     font-family: var(--sb-font-ui);
     transition: background var(--sb-transition), color var(--sb-transition), border-color var(--sb-transition);
     border: 1px solid var(--sb-border);
     width: 100%;
   }
   .sb-quick-btn:hover {
     background: rgba(255, 255, 255, 0.06);
     color: var(--sb-text);
     border-color: var(--sb-border-mid);
   }
   
   /* ─────────────────────────────────────────────────────────────
      Footer
   ───────────────────────────────────────────────────────────── */
   .sb-footer {
     padding: 12px 18px 20px;
     display: flex;
     align-items: center;
     justify-content: space-between;
     flex-shrink: 0;
   }
   
   .sb-version {
     font-family: var(--sb-font-mono);
     font-size: 10px;
     color: var(--sb-text-dim);
     background: rgba(255, 255, 255, 0.04);
     border: 1px solid var(--sb-border);
     border-radius: 5px;
     padding: 3px 8px;
     letter-spacing: 0.04em;
   }
   
   .sb-copy {
     font-size: 10px;
     color: var(--sb-text-dim);
     font-family: var(--sb-font-ui);
     letter-spacing: 0.02em;
   }
   
   /* ─────────────────────────────────────────────────────────────
      Animations
   ───────────────────────────────────────────────────────────── */
   @keyframes sbSlideDown {
     from { opacity: 0; transform: translateY(-8px); }
     to   { opacity: 1; transform: translateY(0);    }
   }
   
   /* ── Logo image ─────────────────────────────────────── */
   .sb-logo-img {
     max-width: 175px;
     height: auto;
     object-fit: contain;
   }
   `, "",{"version":3,"sources":["webpack://./src/styles/Sidebar.css"],"names":[],"mappings":"AAAA;;;;;;;iEAOiE;;GAI9D,iEAAiE;GACjE;KACE,yBAAyB;KACzB,yBAAyB;KACzB,yCAAyC;KACzC,yCAAyC;KACzC,yBAAyB;KACzB,wCAAwC;KACxC,yCAAyC;KACzC,yBAAyB;KACzB,yBAAyB;KACzB,yBAAyB;KACzB,yBAAyB;KACzB,yBAAyB;KACzB,8DAA8D;KAC9D,wDAAwD;KACxD,8CAA8C;KAC9C,qBAAqB;KACrB,qBAAqB;KACrB,oDAAoD;KACpD,uBAAuB;GACzB;;GAEA;;kEAE+D;GAC/D;KACE,sBAAsB;KACtB,0BAA0B;KAC1B,aAAa;KACb,8BAA8B;KAC9B,2FAA2F;KAC3F,aAAa;KACb,sBAAsB;KACtB,eAAe;KACf,MAAM;KACN,OAAO;KACP,YAAY;KACZ,wCAAwC;KACxC,+CAA+C;KAC/C,gBAAgB;KAChB,kBAAkB;KAClB,qBAAqB;GACvB;GACA,iCAAiC,aAAa,EAAE;;GAEhD;;kEAE+D;GAC/D;KACE,WAAW;KACX,aAAa;KACb,wBAAwB;KACxB,aAAa;KACb,sBAAsB;KACtB,mBAAmB;KACnB,eAAe;KACf,MAAM;KACN,OAAO;KACP,YAAY;KACZ,wCAAwC;KACxC,oBAAoB;KACpB,MAAM;GACR;;GAEA;KACE,WAAW;KACX,YAAY;KACZ,gCAAgC;KAChC,yCAAyC;KACzC,mBAAmB;KACnB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,uBAAuB;KACvB,mBAAmB;KACnB,4CAA4C;KAC5C,cAAc;GAChB;;GAEA;KACE,SAAO;KACP,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,eAAe;KACf,WAAW;GACb;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,WAAW;KACX,YAAY;KACZ,kBAAkB;KAClB,qBAAqB;KACrB,qBAAqB;KACrB,uEAAuE;GACzE;GACA;KACE,iCAAiC;KACjC,qBAAqB;GACvB;GACA;KACE,gCAAgC;KAChC,uBAAuB;KACvB,wCAAwC;KACxC,4CAA4C;GAC9C;;GAEA;KACE,gBAAgB;KAChB,gBAAgB;KAChB,kCAAkC;KAClC,kBAAkB;KAClB,eAAe;KACf,qBAAqB;KACrB,YAAY;KACZ,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,0GAA0G;GAC5G;GACA;KACE,iCAAiC;KACjC,qBAAqB;KACrB,kCAAkC;GACpC;;GAEA;;kEAE+D;GAC/D;KACE,uBAAuB;KACvB,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,QAAQ;KACR,cAAc;KACd,gBAAgB;GAClB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,SAAO;KACP,YAAY;KACZ,gBAAgB;GAClB;;GAEA;KACE,WAAW;KACX,YAAY;KACZ,6FAA6F;KAC7F,wCAAwC;KACxC,mBAAmB;KACnB,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,cAAc;KACd,cAAc;KACd,oFAAoF;GACtF;;GAEA;KACE,iCAAiC;KACjC,eAAe;KACf,gBAAgB;KAChB,cAAc;KACd,uBAAuB;KACvB,gBAAgB;GAClB;;GAEA;KACE,gCAAgC;KAChC,gBAAgB;KAChB,gBAAgB;KAChB,yBAAyB;KACzB,sBAAsB;KACtB,yBAAyB;KACzB,eAAe;GACjB;;GAEA;KACE,gBAAgB;KAChB,kCAAkC;KAClC,kBAAkB;KAClB,eAAe;KACf,qBAAqB;KACrB,YAAY;KACZ,aAAa;KACb,mBAAmB;KACnB,uBAAuB;KACvB,cAAc;KACd,0GAA0G;GAC5G;GACA;KACE,qCAAqC;KACrC,qBAAqB;KACrB,kCAAkC;GACpC;;GAEA;;kEAE+D;GAC/D;KACE,WAAW;KACX,4BAA4B;KAC5B,cAAc;KACd,cAAc;GAChB;;GAEA;KACE,sBAAsB;KACtB,gBAAgB;KAChB,gBAAgB;KAChB,qBAAqB;KACrB,yBAAyB;KACzB,gCAAgC;KAChC,yBAAyB;KACzB,cAAc;GAChB;;GAEA;;kEAE+D;GAC/D;KACE,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,eAAe;KACf,cAAc;GAChB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,kBAAkB;GACpB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,SAAS;KACT,SAAO;KACP,qBAAqB;KACrB,kBAAkB;KAClB,+BAA+B;KAC/B,yBAAyB;KACzB,eAAe;KACf,gBAAgB;KAChB,8BAA8B;KAC9B,sBAAsB;KACtB,wGAAwG;KACxG,kBAAkB;KAClB,gBAAgB;KAChB,6BAA6B;GAC/B;;GAEA,yDAAyD;GACzD;KACE,WAAW;KACX,gBAAgB;KAChB,eAAe;KACf,gBAAgB;GAClB;;GAEA;;KAEE,qCAAqC;KACrC,qBAAqB;GACvB;;GAEA;KACE,4FAA4F;KAC5F,cAAc;KACd,gBAAgB;KAChB,qCAAqC;KACrC,uFAAuF;GACzF;;GAEA,oCAAoC;GACpC;KACE,kBAAkB;KAClB,OAAO;KACP,QAAQ;KACR,WAAW;KACX,UAAU;KACV,4BAA4B;KAC5B,0BAA0B;KAC1B,2CAA2C;GAC7C;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,qBAAqB;KACrB,cAAc;KACd,sCAAsC;GACxC;GACA,uBAAuB,uBAAuB,EAAE;;GAEhD;KACE,uBAAuB;GACzB;;GAEA;KACE,SAAO;KACP,mBAAmB;KACnB,gBAAgB;KAChB,uBAAuB;GACzB;;GAEA,0CAA0C;GAC1C;KACE,aAAa;KACb,mBAAmB;KACnB,qBAAqB;KACrB,cAAc;KACd,iBAAiB;KACjB,iBAAiB;GACnB;;GAEA,4EAA4E;;GAE5E;;kEAE+D;GAC/D;KACE,yBAAyB;KACzB,8CAA8C;KAC9C,kBAAkB;KAClB,aAAa;KACb,sBAAsB;KACtB,QAAQ;KACR,wDAAwD;GAC1D;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,wBAAwB;KACxB,qBAAqB;KACrB,iBAAiB;KACjB,kBAAkB;KAClB,eAAe;KACf,gBAAgB;KAChB,8BAA8B;KAC9B,sBAAsB;KACtB,gBAAgB;KAChB,mBAAmB;KACnB,uEAAuE;KACvE,kBAAkB;KAClB,6BAA6B;GAC/B;;GAEA,sDAAsD;GACtD;KACE,WAAW;KACX,gBAAgB;KAChB,eAAe;KACf,gBAAgB;GAClB;;GAEA;;KAEE,qCAAqC;KACrC,cAAc;GAChB;;GAEA;KACE,mBAAmB;KACnB,cAAc;KACd,gBAAgB;KAChB,qCAAqC;GACvC;;GAEA,eAAe,wBAAwB,EAAE,sCAAsC,EAAE,cAAc,EAAE,aAAa,EAAE,mBAAmB,EAAE;GACrI,uBAAuB,uBAAuB,EAAE;;GAEhD;KACE,iBAAiB;KACjB,UAAU;KACV,WAAW;KACX,kBAAkB;KAClB,4BAA4B;KAC5B,0CAA0C;KAC1C,cAAc;GAChB;;GAEA;yEACsE;GACtE;KACE,aAAa;KACb,mBAAmB;KACnB,cAAc;KACd,cAAc;KACd,iBAAiB;KACjB,iBAAiB;KACjB,aAAa;GACf;;GAEA;KACE,WAAW;KACX,YAAY;GACd;;GAEA;;;kEAG+D;GAC/D;KACE,aAAa;KACb,kBAAkB;GACpB;;GAEA;KACE,iBAAiB;KACjB,eAAe;KACf,mBAAmB;GACrB;;GAEA;;;;;kEAK+D;GAC/D;KACE,sBAAsB;KACtB,8CAA8C;KAC9C,iBAAiB;GACnB;;GAEA;KACE,iBAAiB;KACjB,eAAe;KACf,QAAQ;GACV;;GAEA;KACE,YAAY;GACd;;GAEA;;kEAE+D;GAC/D;KACE,sBAAsB;GACxB;;GAEA;KACE,aAAa;KACb,mBAAmB;KACnB,QAAQ;KACR,yBAAyB;KACzB,qBAAqB;KACrB,iBAAiB;KACjB,+BAA+B;KAC/B,eAAe;KACf,gBAAgB;KAChB,8BAA8B;KAC9B,0GAA0G;KAC1G,kCAAkC;KAClC,WAAW;GACb;GACA;KACE,qCAAqC;KACrC,qBAAqB;KACrB,kCAAkC;GACpC;;GAEA;;kEAE+D;GAC/D;KACE,uBAAuB;KACvB,aAAa;KACb,mBAAmB;KACnB,8BAA8B;KAC9B,cAAc;GAChB;;GAEA;KACE,gCAAgC;KAChC,eAAe;KACf,yBAAyB;KACzB,qCAAqC;KACrC,kCAAkC;KAClC,kBAAkB;KAClB,gBAAgB;KAChB,sBAAsB;GACxB;;GAEA;KACE,eAAe;KACf,yBAAyB;KACzB,8BAA8B;KAC9B,sBAAsB;GACxB;;GAEA;;kEAE+D;GAC/D;KACE,OAAO,UAAU,EAAE,2BAA2B,EAAE;KAChD,OAAO,UAAU,EAAE,wBAAwB,KAAK;GAClD;;GAEA,0DAA0D;GAC1D;KACE,gBAAgB;KAChB,YAAY;KACZ,mBAAmB;GACrB","sourcesContent":["/* ============================================================\n   Sidebar.css  —  KinetiQ premium sidebar\n   Design: deep slate-navy, #28a745 accent, scientific SaaS\n   Tracker #6:  larger font, button-style items, more spacing\n   Tracker #7:  highly visible active state (glow + bar + bg)\n   Tracker #8:  generous padding throughout\n   Help menu:   scroll-select dropdown (button, not link)\n   ============================================================ */\n\n   @import url('https://fonts.googleapis.com/css2?family=DM+Sans:wght@400;500;600;700&family=Syne:wght@700;800&family=DM+Mono:wght@400;500&display=swap');\n\n   /* ── Design tokens ─────────────────────────────────────────── */\n   :root {\n     --sb-bg:          #1A3C6E;\n     --sb-surface:     #1e2c3e;\n     --sb-border:      rgba(252, 13, 13, 0.07);\n     --sb-border-mid:  rgba(245, 26, 26, 0.12);\n     --sb-accent:      #07c436;\n     --sb-accent-dim:  rgba(4, 240, 59, 0.14);\n     --sb-accent-glow: rgba(12, 238, 65, 0.35);\n     --sb-icon:        #6b8699;\n     --sb-subicon:     #fdfdfd;\n     --sb-text:        #000408;\n     --sb-text-mid:    #fdfdfd;\n     --sb-text-dim:    #fdfdfd;\n     --sb-font-ui:     'DM Sans', 'Segoe UI', system-ui, sans-serif;\n     --sb-font-mono:   'DM Mono', 'JetBrains Mono', monospace;\n     --sb-font-brand:  'Syne', 'Lexend', sans-serif;\n     --sb-radius:      9px;\n     --sb-radius-sm:   6px;\n     --sb-transition:  0.16s cubic-bezier(0.4, 0, 0.2, 1);\n     --sb-width:       242px;\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Full sidebar\n   ───────────────────────────────────────────────────────────── */\n   .sb-sidebar {\n     width: var(--sb-width);\n     min-width: var(--sb-width);\n     height: 100vh;\n     /* background: var(--sb-bg); */\n     background: linear-gradient(160deg, var(--sb-bg) 0%, #0E2A52 55%, var(--kinetic-dark) 100%);\n     display: flex;\n     flex-direction: column;\n     position: fixed;\n     top: 0;\n     left: 0;\n     z-index: 100;\n     border-right: 1px solid var(--sb-border);\n     box-shadow: 4px 0 32px rgba(233, 219, 219, 0.4);\n     overflow-y: auto;\n     overflow-x: hidden;\n     scrollbar-width: none;\n   }\n   .sb-sidebar::-webkit-scrollbar { display: none; }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Collapsed rail\n   ───────────────────────────────────────────────────────────── */\n   .sb-rail {\n     width: 58px;\n     height: 100vh;\n     background: var(--sb-bg);\n     display: flex;\n     flex-direction: column;\n     align-items: center;\n     position: fixed;\n     top: 0;\n     left: 0;\n     z-index: 100;\n     border-right: 1px solid var(--sb-border);\n     padding: 16px 0 16px;\n     gap: 0;\n   }\n   \n   .sb-rail-logo {\n     width: 38px;\n     height: 38px;\n     background: var(--sb-accent-dim);\n     border: 1px solid rgba(40, 167, 69, 0.35);\n     border-radius: 10px;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     color: var(--sb-accent);\n     margin-bottom: 16px;\n     box-shadow: 0 0 14px rgba(40, 167, 69, 0.15);\n     flex-shrink: 0;\n   }\n   \n   .sb-rail-nav {\n     flex: 1;\n     display: flex;\n     flex-direction: column;\n     gap: 4px;\n     padding: 0 10px;\n     width: 100%;\n   }\n   \n   .sb-rail-item {\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     width: 38px;\n     height: 38px;\n     border-radius: 9px;\n     color: var(--sb-icon);\n     text-decoration: none;\n     transition: background var(--sb-transition), color var(--sb-transition);\n   }\n   .sb-rail-item:hover {\n     background: rgba(236, 8, 8, 0.06);\n     color: var(--sb-text);\n   }\n   .sb-rail-item--active {\n     background: var(--sb-accent-dim);\n     color: var(--sb-accent);\n     border: 1px solid rgba(40, 167, 69, 0.3);\n     box-shadow: 0 0 10px rgba(40, 167, 69, 0.15);\n   }\n   \n   .sb-rail-expand {\n     margin-top: auto;\n     background: none;\n     border: 1px solid var(--sb-border);\n     border-radius: 8px;\n     cursor: pointer;\n     color: var(--sb-icon);\n     padding: 7px;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     transition: background var(--sb-transition), color var(--sb-transition), border-color var(--sb-transition);\n   }\n   .sb-rail-expand:hover {\n     background: rgba(235, 8, 8, 0.07);\n     color: var(--sb-text);\n     border-color: var(--sb-border-mid);\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Header\n   ───────────────────────────────────────────────────────────── */\n   .sb-header {\n     padding: 20px 16px 16px;\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     gap: 8px;\n     flex-shrink: 0;\n     overflow: hidden;\n   }\n   \n   .sb-logo-row {\n     display: flex;\n     align-items: center;\n     gap: 11px;\n     flex: 1;\n     min-width: 0;\n     overflow: hidden;\n   }\n   \n   .sb-logo-mark {\n     width: 40px;\n     height: 40px;\n     background: linear-gradient(135deg, rgba(40, 167, 69, 0.22) 0%, rgba(40, 167, 69, 0.06) 100%);\n     border: 1px solid rgba(40, 167, 69, 0.4);\n     border-radius: 11px;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     color: #28a745;\n     flex-shrink: 0;\n     box-shadow: 0 0 16px rgba(223, 83, 3, 0.18), inset 0 1px 0 rgba(255, 255, 255, 0.06);\n   }\n   \n   .sb-logo-name {\n     font-family: var(--sb-font-brand);\n     font-size: 19px;\n     font-weight: 800;\n     color: #068af7;\n     letter-spacing: -0.03em;\n     line-height: 1.1;\n   }\n   \n   .sb-logo-tag {\n     font-family: var(--sb-font-mono);\n     font-size: 9.5px;\n     font-weight: 500;\n     color: var(--sb-text-dim);\n     letter-spacing: 0.07em;\n     text-transform: uppercase;\n     margin-top: 2px;\n   }\n   \n   .sb-collapse-btn {\n     background: none;\n     border: 1px solid var(--sb-border);\n     border-radius: 7px;\n     cursor: pointer;\n     color: var(--sb-icon);\n     padding: 5px;\n     display: flex;\n     align-items: center;\n     justify-content: center;\n     flex-shrink: 0;\n     transition: background var(--sb-transition), color var(--sb-transition), border-color var(--sb-transition);\n   }\n   .sb-collapse-btn:hover {\n     background: rgba(255, 255, 255, 0.07);\n     color: var(--sb-text);\n     border-color: var(--sb-border-mid);\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Dividers & labels\n   ───────────────────────────────────────────────────────────── */\n   .sb-divider {\n     height: 1px;\n     background: var(--sb-border);\n     margin: 0 16px;\n     flex-shrink: 0;\n   }\n   \n   .sb-section-label {\n     padding: 14px 20px 6px;\n     font-size: 9.5px;\n     font-weight: 600;\n     letter-spacing: 0.1em;\n     color: var(--sb-text-dim);\n     font-family: var(--sb-font-mono);\n     text-transform: uppercase;\n     flex-shrink: 0;\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Nav items\n   ───────────────────────────────────────────────────────────── */\n   .sb-nav {\n     display: flex;\n     flex-direction: column;\n     gap: 3px;\n     padding: 0 10px;\n     flex-shrink: 0;\n   }\n   \n   .sb-nav-row {\n     display: flex;\n     align-items: center;\n     position: relative;\n   }\n   \n   .sb-nav-link {\n     display: flex;\n     align-items: center;\n     gap: 10px;\n     flex: 1;\n     text-decoration: none;\n     padding: 10px 12px;\n     border-radius: var(--sb-radius);\n     color: var(--sb-text-mid);\n     font-size: 20px;\n     font-weight: 500;\n     font-family: var(--sb-font-ui);\n     letter-spacing: 0.01em;\n     transition: background var(--sb-transition), color var(--sb-transition), box-shadow var(--sb-transition);\n     position: relative;\n     overflow: hidden;\n     border: 1px solid transparent;\n   }\n   \n   /* Button-reset for nav items that are <button> not <a> */\n   .sb-nav-link--btn {\n     width: 100%;\n     background: none;\n     cursor: pointer;\n     text-align: left;\n   }\n   \n   .sb-nav-link:hover,\n   .sb-nav-link--hover {\n     background: rgba(255, 255, 255, 0.05);\n     color: var(--sb-text);\n   }\n   \n   .sb-nav-link--active {\n     background: linear-gradient(90deg, rgba(40, 167, 69, 0.18) 0%, rgba(40, 167, 69, 0.05) 100%);\n     color: #ffffff;\n     font-weight: 600;\n     border-color: rgba(40, 167, 69, 0.28);\n     box-shadow: 0 2px 12px rgba(40, 167, 69, 0.14), inset 0 1px 0 rgba(255, 255, 255, 0.05);\n   }\n   \n   /* Green accent bar on active item */\n   .sb-accent-bar {\n     position: absolute;\n     left: 0;\n     top: 18%;\n     bottom: 18%;\n     width: 3px;\n     background: var(--sb-accent);\n     border-radius: 0 3px 3px 0;\n     box-shadow: 0 0 10px rgba(40, 167, 69, 0.7);\n   }\n   \n   .sb-nav-icon {\n     display: flex;\n     align-items: center;\n     color: var(--sb-icon);\n     flex-shrink: 0;\n     transition: color var(--sb-transition);\n   }\n   .sb-nav-icon--active { color: var(--sb-accent); }\n   \n   .sb-nav-link--active .sb-nav-icon {\n     color: var(--sb-accent);\n   }\n   \n   .sb-nav-label {\n     flex: 1;\n     white-space: nowrap;\n     overflow: hidden;\n     text-overflow: ellipsis;\n   }\n   \n   /* Chevron inline inside the Help button */\n   .sb-help-chevron {\n     display: flex;\n     align-items: center;\n     color: var(--sb-icon);\n     flex-shrink: 0;\n     margin-left: auto;\n     padding-left: 4px;\n   }\n   \n   /* .sb-chevron-btn removed — chevron is now embedded inside the nav button */\n   \n   /* ─────────────────────────────────────────────────────────────\n      Sub-menu  (shared — Data Fitting & Help)\n   ───────────────────────────────────────────────────────────── */\n   .sb-sub-menu {\n     margin: 2px 10px 4px 32px;\n     border-left: 1px solid rgba(40, 167, 69, 0.22);\n     padding-left: 10px;\n     display: flex;\n     flex-direction: column;\n     gap: 1px;\n     animation: sbSlideDown 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n   }\n   \n   .sb-sub-link {\n     display: flex;\n     align-items: center;\n     gap: 8px;\n     color: var(--sb-subicon);\n     text-decoration: none;\n     padding: 5px 22px;\n     border-radius: 7px;\n     font-size: 18px;\n     font-weight: 500;\n     font-family: var(--sb-font-ui);\n     letter-spacing: 0.01em;\n     line-height: 1.2;\n     white-space: nowrap;\n     transition: background var(--sb-transition), color var(--sb-transition);\n     position: relative;\n     border: 1px solid transparent;\n   }\n   \n   /* Button-reset for help sub-items that are <button> */\n   .sb-sub-link--btn {\n     width: 100%;\n     background: none;\n     cursor: pointer;\n     text-align: left;\n   }\n   \n   .sb-sub-link:hover,\n   .sb-sub-link--hover {\n     background: rgba(255, 255, 255, 0.05);\n     color: #ccb3a4;\n   }\n   \n   .sb-sub-link--active {\n     background: #ffffff;\n     color: #0a1a12;\n     font-weight: 600;\n     border-color: rgba(40, 167, 69, 0.25);\n   }\n   \n   .sb-sub-icon { color: var(--sb-subicon); transition: color var(--sb-transition); flex-shrink: 0; display: flex; align-items: center; }\n   .sb-sub-icon--active { color: var(--sb-accent); }\n   \n   .sb-sub-dot {\n     margin-left: auto;\n     width: 5px;\n     height: 5px;\n     border-radius: 50%;\n     background: var(--sb-accent);\n     box-shadow: 0 0 6px rgba(40, 167, 69, 0.8);\n     flex-shrink: 0;\n   }\n   \n   /* Chevron on the \"User Guide\" row — same rotate-on-expand behavior as\n      the top-level Help chevron, scaled down to sit inside a sub-link. */\n   .sb-guide-chevron {\n     display: flex;\n     align-items: center;\n     color: inherit;\n     flex-shrink: 0;\n     margin-left: auto;\n     padding-left: 4px;\n     opacity: 0.75;\n   }\n   \n   .sb-guide-chevron svg {\n     width: 10px;\n     height: 10px;\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Help sub-menu overrides\n      Slightly tighter indent since Help items have their own icons\n   ───────────────────────────────────────────────────────────── */\n   .sb-help-menu {\n     margin-top: 0;\n     margin-bottom: 6px;\n   }\n   \n   .sb-help-menu .sb-sub-link {\n     padding: 6px 14px;\n     font-size: 18px;\n     white-space: nowrap;\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      User Guide section list — nested one level under \"User Guide\"\n      itself, inside the Help sub-menu. Dynamic loading: each link is\n      /userguide plus a different hash, so clicking swaps the guide's\n      content in place rather than leaving the page.\n   ───────────────────────────────────────────────────────────── */\n   .sb-guide-menu {\n     margin: 2px 0 6px 24px;\n     border-left: 1px solid rgba(40, 167, 69, 0.16);\n     padding-left: 8px;\n   }\n   \n   .sb-guide-menu .sb-sub-link {\n     padding: 5px 12px;\n     font-size: 15px;\n     gap: 8px;\n   }\n   \n   .sb-guide-menu .sb-sub-icon svg {\n     opacity: 0.7;\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Quick actions\n   ───────────────────────────────────────────────────────────── */\n   .sb-quick-actions {\n     padding: 4px 10px 10px;\n   }\n   \n   .sb-quick-btn {\n     display: flex;\n     align-items: center;\n     gap: 9px;\n     color: var(--sb-text-mid);\n     text-decoration: none;\n     padding: 9px 12px;\n     border-radius: var(--sb-radius);\n     font-size: 13px;\n     font-weight: 400;\n     font-family: var(--sb-font-ui);\n     transition: background var(--sb-transition), color var(--sb-transition), border-color var(--sb-transition);\n     border: 1px solid var(--sb-border);\n     width: 100%;\n   }\n   .sb-quick-btn:hover {\n     background: rgba(255, 255, 255, 0.06);\n     color: var(--sb-text);\n     border-color: var(--sb-border-mid);\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Footer\n   ───────────────────────────────────────────────────────────── */\n   .sb-footer {\n     padding: 12px 18px 20px;\n     display: flex;\n     align-items: center;\n     justify-content: space-between;\n     flex-shrink: 0;\n   }\n   \n   .sb-version {\n     font-family: var(--sb-font-mono);\n     font-size: 10px;\n     color: var(--sb-text-dim);\n     background: rgba(255, 255, 255, 0.04);\n     border: 1px solid var(--sb-border);\n     border-radius: 5px;\n     padding: 3px 8px;\n     letter-spacing: 0.04em;\n   }\n   \n   .sb-copy {\n     font-size: 10px;\n     color: var(--sb-text-dim);\n     font-family: var(--sb-font-ui);\n     letter-spacing: 0.02em;\n   }\n   \n   /* ─────────────────────────────────────────────────────────────\n      Animations\n   ───────────────────────────────────────────────────────────── */\n   @keyframes sbSlideDown {\n     from { opacity: 0; transform: translateY(-8px); }\n     to   { opacity: 1; transform: translateY(0);    }\n   }\n   \n   /* ── Logo image ─────────────────────────────────────── */\n   .sb-logo-img {\n     max-width: 175px;\n     height: auto;\n     object-fit: contain;\n   }\n   "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
